module.exports = __webpack_public_path__ + "FontAwesome.0d2717cd5d853e5c765c.otf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/fonts/FontAwesome.otf
// module id = ../../../../../src/assets/fonts/FontAwesome.otf
// module chunks = 1